import React, {createRef} from 'react'

import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../gd-components/buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../../gd-components/buttons/control-button/@types"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import ErrorBoundary from "../../../../../error-boundary"
import {ExpandedStatus, SelectParent_SectionType} from "../../../@const"
import ProjectSession from "../../../../../model2/project/project-session"
import ProjectTree_New, {ITreeSelectorParent} from "../../tree-new/project-tree-new"
import SelectParentNew from "../../../select-parent-new"
import SelectParentsNew from "../../../select-parents-new"
import {ProjectsTreeSortType} from "../../../../../../layout/menu/components/space-preferences/preferences"
import selectParent_CollapseAll from "../../../actions/collapse-all"
import selectParent_ExpandAll from "../../../actions/expand-all"
import {SpaceProto} from "../../../../../model2/space/space-proto"
import SelectParent_ProjectsNotFound from "./projects-not-found"
import Workspace from "../../../../../model2/space/workspaces/workspace"
import {SpaceProjects} from "../../../../../model2/space/system/projects"
import ProjectFinder from "../../../../../gd-components/finder/project/project-finder"

type Props = {
    // parentSelector      : SelectParentNew | SelectParentsNew | ProjectFinder
    parentSelector      : ITreeSelectorParent
    projects            : ProjectSession[]

    section             : SelectParent_SectionType | SpaceProto

    onParentSelected    : callback
    colorized           : boolean
    sortType            : ProjectsTreeSortType
    notFoundMessage     : string

    applyTreeDisplay?   : boolean
}

// const debug = "SelectParent_CollapsableProjectsTree"
const debug = false

export default class SelectParent_CollapsableProjectsTree extends React.Component<Props> {

    private refProjectTree: any = createRef()

    constructor(props: Props) {
        super(props);
    }

    onExpandAll = ()=>{
        if (this.props.section instanceof Workspace) {
            // start from workspace as first level
            (this.props.section as Workspace).project.treeIsExpandedProjectSelector = true
        } else if (this.props.section instanceof SpaceProjects) {
            // start from "Projects" as first level
            this.refProjectTree.current.onToggleRootExpand(true)
        }

        selectParent_ExpandAll(this.props.projects)

        this.forceUpdate()
    }

    onCollapseAll = ()=>{
        if (this.props.section instanceof Workspace) {
            // start from workspace as first level
            (this.props.section as Workspace).project.treeIsExpandedProjectSelector = false
        } else if (this.props.section instanceof SpaceProjects) {
            // start from "Projects" as first level
            this.refProjectTree.current.onToggleRootExpand(false)
        }

        selectParent_CollapseAll(this.props.projects)

        this.forceUpdate()
    }

    onToggleExpand = (project: ProjectSession)=> {
        project.treeIsExpandedProjectSelector = !project.treeIsExpandedProjectSelector
        this.forceUpdate()
    }

    render() {

        debug && console.log(debug, "render() rootProjectsTotal=", this.props.projects.length)

        if (_.isEmpty(this.props.projects)) {
            // show "Not found" only if section is not Workspace or workspace roots are not displayed
            if (!this.props.parentSelector.props.displayWorkspaceRoot || !(this.props.section instanceof Workspace)) {
                return <SelectParent_ProjectsNotFound notFoundMessage={this.props.notFoundMessage}/>
            }
        }

        let projects : ProjectSession[] = this.props.projects

        return (
            <div className="flex-column-right-top w-100-percent h-100-percent">
                <div className="flex-row-right-center h-36 p-h-8">
                    <ControlButtonStandard type         = {ControlButtonType.COLLAPSE_ALL}
                                           size         = {ControlButtonSize.SIZE_24}
                                           onClick      = {this.onCollapseAll}
                                           hint         = "Collapse All"/>

                    <ControlButtonStandard type         = {ControlButtonType.EXPAND_ALL}
                                           size         = {ControlButtonSize.SIZE_24}
                                           onClick      = {this.onExpandAll}
                                           hint         = "Expand All"/>
                </div>

                <VScroll className="h-100-percent p-b-10">
                    <ErrorBoundary>
                        <div className="ui5-menu p-0">
                            <ProjectTree_New ref                = {this.refProjectTree}
                                             colorized          = {this.props.colorized}
                                             parentSelector     = {this.props.parentSelector}
                                             sortType           = {this.props.sortType}
                                             rootProjects       = {projects}
                                             section            = {this.props.section}
                                             onSelect           = {this.props.onParentSelected}
                                             onToggleExpand     = {this.onToggleExpand}
                                             applyTreeDisplay   = {this.props.applyTreeDisplay}/>
                        </div>
                    </ErrorBoundary>
                </VScroll>
            </div>
        )
    }
}
